import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

const RdpPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!email) {
      setError('Please enter a valid email address.');
      return;
    }

    try {
      const response = await fetch('https://formspree.io/f/mwvaqkop', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      
      if (response.ok || data.ok) {
        setSubmitted(true);
        setEmail('');
      } else {
        // Display the actual error from Formspree
        const errorMsg = data.error || data.errors?.[0]?.message || 'Unable to send your request. Please try again later.';
        setError(errorMsg);
        console.error('Formspree error:', data);
      }
    } catch (err) {
      console.error('Submission error:', err);
      setError('Network error. Please try again in a moment.');
    }
  };

  return (
    <div className="min-h-screen bg-dark-bg text-text-primary flex items-center justify-center py-16 px-6 sm:px-8">
      <SEO title="RDP Coming Soon | NexaProxy" description="RDP access is coming soon to NexaProxy. Sign up for email notification for early access." />
      <div className="w-full max-w-3xl rounded-[2rem] border border-accent/15 bg-dark-secondary/90 p-10 shadow-2xl backdrop-blur-xl">
        <div className="space-y-8 text-center">
          <span className="inline-flex items-center justify-center rounded-full bg-accent/10 px-4 py-2 text-accent font-semibold uppercase tracking-[0.28em] text-xs">
            Remote Desktop Protocol
          </span>
          <div className="space-y-4">
            <h1 className="text-4xl sm:text-5xl font-semibold text-white">RDP access is launching soon</h1>
            <p className="mx-auto max-w-2xl text-base text-text-secondary sm:text-lg">
                NexaProxy is building a premium Remote Desktop experience with enterprise-grade performance and security.  Join the waiting list for early access. A limited number of users will be randomly selected to receive a free package plan.
            </p>
          </div>
          <div className="mx-auto w-full max-w-xl rounded-3xl border border-accent/10 bg-dark-bg p-6">
            {submitted ? (
              <div className="space-y-4 text-center">
                <p className="text-lg font-semibold text-white">Thank you.</p>
                <p className="text-text-secondary">
                  We will notify you by email when NexaProxy RDP is available.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <label htmlFor="notify-email" className="text-sm font-medium uppercase tracking-[0.18em] text-text-secondary">
                  Notify me by email
                </label>
                <div className="grid gap-3 sm:grid-cols-[1fr_auto]">
                  <input
                    id="notify-email"
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your business email"
                    className="w-full rounded-2xl border border-accent/10 bg-dark-bg px-4 py-3 text-text-primary placeholder-text-secondary outline-none transition focus:border-accent focus:ring-2 focus:ring-accent/20"
                  />
                  <button
                    type="submit"
                    className="inline-flex items-center justify-center rounded-2xl bg-accent px-5 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-accent-hover"
                  >
                    Notify Me
                  </button>
                </div>
                {error && <p className="text-xs text-red-400">{error}</p>}
                <p className="text-xs text-text-secondary">
                  We respect your privacy. No spam, just launch updates and priority access details.
                </p>
              </form>
            )}
          </div>

          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-full border border-accent/20 bg-transparent px-7 py-4 text-base font-semibold text-accent transition-colors duration-300 hover:bg-accent/10"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RdpPage;
